import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const TestimonialWrapper = styled.div`
	width: 100%;
	padding: 64px 0;
	${media.large`
    padding: 112px 0;
  `}
`;
